import { IGetFeedsDTO } from '@/models/feeds.model';
import { TGetFeedsQuery } from '../helpers/types';

class GetFeedDTO implements IGetFeedsDTO {
  slug?: string;
  page?: number;
  name?: string;
  region_ids?: string[];
  category_ids?: string[];
  active?: '1' | '0';
  type?: string;
  generation_type?: 'per_partner' | 'general';

  constructor({
    slug,
    page,
    name,
    category_ids,
    region_ids,
    active,
    type,
    generation_type,
  }: TGetFeedsQuery & {
    page: number;
  }) {
    this.slug = slug;
    this.name = name;
    this.region_ids = region_ids;
    this.category_ids = category_ids;
    if (active) {
      this.active = active;
    }
    this.type = type;
    this.generation_type = generation_type;
    this.page = page;
  }
}

export default GetFeedDTO;
